import { render, staticRenderFns } from "./addEditModal.vue?vue&type=template&id=1f75fe30&scoped=true&"
import script from "./addEditModal.vue?vue&type=script&lang=ts&"
export * from "./addEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75fe30",
  null
  
)

export default component.exports